/**
 * Locale map for marketing/SEO landing pages.
 *
 * Distinct from `i18n/index.ts` SUPPORTED_LOCALES (which governs the in-app
 * UI chrome bundles). This map governs *marketing-page URL routing + hreflang*:
 * which `/xx/` prefix a locale lives under, and which BCP-47 hreflang code it
 * announces to Google. EN is root (no prefix).
 *
 * Adding a locale here is necessary but not sufficient to render its chrome in
 * that language — that also needs a bundle registered in i18n/index.ts. JA + DE
 * already have bundles; FR / ZH-TW will be added when their pages land.
 */
// `zhtw` = Traditional Chinese. Key matches the i18n bundle key (hyphen-free so
// i18next's `load: 'languageOnly'` doesn't fold it onto Simplified `zh`); its
// URL prefix is still `/zh-tw` and its hreflang `zh-Hant`.
export type MarketingLocale =
  | 'en' | 'zh' | 'ja' | 'de' | 'fr' | 'zhtw' | 'es' | 'ko' | 'it';

/** URL path prefix per locale. EN is root. e.g. ja → `/ja/transcription`. */
export const LOCALE_PREFIX: Record<MarketingLocale, string> = {
  en: '',
  zh: '/zh',
  ja: '/ja',
  de: '/de',
  fr: '/fr',
  zhtw: '/zh-tw',
  es: '/es',
  ko: '/ko',
  it: '/it',
};

/** BCP-47 hreflang code emitted in `<link rel="alternate">`. zh is Simplified
 *  (zh-Hans); zhtw is Traditional (zh-Hant). */
export const LOCALE_HREFLANG: Record<MarketingLocale, string> = {
  en: 'en',
  zh: 'zh-Hans',
  ja: 'ja',
  de: 'de',
  fr: 'fr',
  zhtw: 'zh-Hant',
  es: 'es',
  ko: 'ko',
  it: 'it',
};
